import { Link } from '@abyss/web/ui/Link';
import { Text } from '@abyss/web/ui/Text';
import React from 'react';

export const getCheckedCount = (selectedCheckbox: any): number =>
  (Object.values(selectedCheckbox?.checked)?.filter((item) => item)
    ?.length as number) ?? 0;

export const getIsCompareNow = (
  provider: any,
  selectedCheckbox: any
): boolean =>
  getCheckedCount(selectedCheckbox) >= 2 &&
  Object.keys(selectedCheckbox.checked)
    ?.filter((item) => selectedCheckbox?.checked[item])
    .includes(provider?.locationId);

export const getIsOneChecked = (
  _provider: any,
  selectedCheckbox: any
): boolean => getCheckedCount(selectedCheckbox) === 1;

/**
 * Shared compare label renderer used by DataCard and DataCardList.
 *
 * **With enableCompareButtonRelocation = true:**
 * - 0 checked                         → addToCompareText (all rows)
 * - 1+ checked, not a "compare now"   → selectMoreToCompareText (all non-active rows)
 * - 2+ checked & this provider is one → "Compare X Now" link
 */

export const renderCompareLabel = (
  provider: any,
  selectedCheckbox: any,
  compareNowLinkText: string | undefined,
  addToCompareText: string | undefined,
  selectMoreToCompareText: string | undefined,
  setIsCompareClicked: (() => void) | undefined,
  enableCompareButtonRelocation: boolean = false,
  textAlign: 'center' | 'left' = 'left',
  extraCss: object = {}
): React.ReactElement | null => {
  const isCompareNow = getIsCompareNow(provider, selectedCheckbox);
  const checkedCount = getCheckedCount(selectedCheckbox);

  if (isCompareNow) {
    return (
      <Link
        css={{
          '&:hover::before': { display: 'none' },
          fontSize: '14px',
          textAlign,
          ...extraCss,
        }}
        data-testid="compare-now-button"
        onClick={setIsCompareClicked}
      >
        {compareNowLinkText?.replace('{{X}}', String(checkedCount))}
      </Link>
    );
  }

  if (enableCompareButtonRelocation && checkedCount >= 1) {
    return (
      <Text css={{ fontSize: 14, fontWeight: '600', textAlign, ...extraCss }}>
        {selectMoreToCompareText}
      </Text>
    );
  }

  return (
    <Text
      css={{
        fontSize: 14,
        fontWeight: enableCompareButtonRelocation ? '600' : '400',
        textAlign,
        ...extraCss,
      }}
    >
      {addToCompareText}
    </Text>
  );
};
